import React, { Component } from 'react';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter, Link, Redirect } from 'react-router-dom';
import moment from 'moment-timezone';
import GoBackButton from '../../../components/GoBackButton';
import Header from '../../../components/Header';
import Input from '../../../components/Input';

let cancelToken;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

const periodos = [
    null,
    { name: '1 Mes', multi_by: 1 },
    { name: '3 Meses', multi_by: 3 },
    { name: '6 Meses', multi_by: 6 },
    { name: '12 Meses', multi_by: 12 }
]

class PaymentDomicilioContainerCowork extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // centers: [],
            cowork: null,
            email: "",
            name: "",
            lastname: "",
            phone: "",
            centro_id: "",
            duracion_id: 2,
            // duracion_str: "1 Semana",
            // precio: null,
            city: null,
            new_date: new Date().toISOString().split('T')[0],
            fieldsValid: {}
        }
    }

    componentDidMount() {
        const data = window.sessionStorage.getItem('paymentData');
        if (data) {
            const json = JSON.parse(data);
            this.setState({
                ...json,
                duracion_id: json.duracion_id_cowork || 2,
            })
        };
        cancelToken = axios.CancelToken.source();

        this.reload();
        this.getCowork({
            token_id: this.props.getTokenId(),
            cowork_id: this.props.match.params.coworkid
        })
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        const keys = ['email', 'name', 'lastname', 'phone', 'duracion_id'];
        // Se piensa eliminar duracion_str y precio ya que son datos que se pueden calcular con la duracion_id y el backend

        const data = keys.reduce((acc, key) => {
            if (key === 'duracion_id') acc['duracion_id_cowork'] = this.state[key];
            else acc[key] = this.state[key];
            return acc;
        }, {});


        window.sessionStorage.setItem('paymentData', JSON.stringify(data));
    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    reload = () => {
        if (this.props.match.params.coworkid) {
            this.setState({
                centro_id: this.props.match.params.coworkid,
                city: this.props.match.params.coworkid
            })
        }
    }

    getCowork = (params) => {
        this.props.post(
            "/getCowork",
            params,
            (cowork) => this.setState({ cowork }),
            () => this.handleError(),
            cancelToken,
            () => this.handleError()
        );
    }

    handleError = () => {
        alert("Cowork no disponible.")
        this.props.history.replace(URI_VENTA_EN_LINEA)
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const period = periodos[this.state.duracion_id];
        const precio = this.state.cowork.precio * period.multi_by;
        if (!period) return alert('Seleccione un periodo de tiempo');

        const isValid = Object.values(this.state.fieldsValid).every(value => value);
        if (!isValid) return alert('Por favor, llene todos los campos correctamente');

        this.props.history.replace({
            pathname: "payment/" + this.state.centro_id + "/" + this.state.duracion_id,
            state: {
                email: this.state.email,
                name: this.state.name,
                lastname: this.state.lastname,
                phone: this.state.phone,
                duracion_id: this.state.duracion_id,
                duracion_str: period.name,
                precio,
                new_date: this.state.new_date
            }
        })
    }

    render() {
        const { t } = this.props;
        const today = new Date();
        // const centers = this.state.centers;
        const cowork = this.state.cowork || {
            centro_id: "",
            centro_name: "...",
        };
        const min_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        // const new_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        const email = this.state.email

        return (
            <form className="content-resvations" onSubmit={this.handleSubmit}>
                <Header>
                    <h2>
                        <Trans>venta_linea.index.cowork.title</Trans>
                    </h2>
                </Header>
                <div className="container-domiciolio">
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms flex-horizontal">
                            <h2 className="page-header">
                                <Trans>venta_linea.payment.personal_info</Trans>
                            </h2>
                            <div className="form-group" style={{ width: '100%' }}>
                                <div className="input-group input-lg-xl">
                                    <div className="form-group">
                                        <select
                                            disabled={true}
                                            className="form-control input-lg"
                                            id="city-select"
                                            value={cowork.centro_id}>
                                            <option value={cowork.centro_id}>
                                                {cowork.centro_name}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div className="input-group-btn-movil">
                                    <Link
                                        to=
                                        {{
                                            pathname: URI_VENTA_EN_LINEA
                                        }}>
                                        <span className="return-store">
                                            <Trans>venta_linea.payment.change_center</Trans>
                                        </span>
                                    </Link>
                                </div>
                                <br></br>
                                <div className="input-group-btn-movil">
                                    <div className="grid-4 price-tags">
                                        {
                                            Object.values(periodos).map((periodo, index) => (
                                                periodo && <button key={index} type="button" onClick={() => this.setState({ duracion_id: index })} className={this.state.duracion_id === index ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                                    <p>{periodo.name}</p>
                                                    <p className="btn_store_text">
                                                        ${cowork.precio ? cowork.precio * periodo.multi_by : 'x,xxx'} MXN <br></br>+ IVA</p>
                                                </button>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms">
                            <div className="forms">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleEmailChange}
                                            placeholder={t('dashboard.room_payment.holder_email')}
                                            required
                                            type="email"
                                            name="email"
                                            onValidate={this.handleValidate}
                                            value={email} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleNameChange}
                                            placeholder={t('dashboard.room_payment.holder_name')}
                                            required
                                            type="text"
                                            name="name"
                                            onValidate={this.handleValidate}
                                            value={this.state.name ? this.state.name : ""} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handleLastnameChange}
                                            placeholder={t('dashboard.room_payment.holder_lastname')}
                                            required
                                            type="text"
                                            name="lastname"
                                            onValidate={this.handleValidate}
                                            value={this.state.lastname ? this.state.lastname : ""} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            autoComplete="off"
                                            className="form-control input-date"
                                            onChange={(e) => this.setState({ new_date: e.target.value })}
                                            placeholder={"Fecha de Inicio"}
                                            required
                                            type="date"
                                            min={min_date}
                                            value={this.state.new_date}
                                            name="new_date"
                                            onValidate={this.handleValidate}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <Input
                                            className="form-control"
                                            onChange={this.handlePhoneChange}
                                            placeholder={t('dashboard.room_payment.holder_phone')}
                                            required
                                            type="tel"
                                            // minlength="8"
                                            // maxlength="12"
                                            pattern="[0-9]{10}"
                                            value={this.state.phone} 
                                            name="phone"
                                            onValidate={this.handleValidate}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <span className="return-store">
                                        * <Trans>venta_linea.payment.accept_contact</Trans>
                                    </span>
                                </div>
                                <div className='row'>
                                    <GoBackButton
                                        isButtonForm
                                        isPayment
                                    />
                                    <button
                                        type='submit'
                                        className="continua_button btn btn-primary col-md-6">
                                        <Trans>dashboard.room_payment.btn_continue</Trans>
                                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }


}

export default compose(
    translate('common'),
    withRouter
)(PaymentDomicilioContainerCowork);


// WEBPACK FOOTER //
// ./src/store/Cowork/Payment/PaymentDomicilioContainerCowork.js